import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FrontendConfigurationService } from '@tourfold/shared-kernels/frontend-configuration';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  private readonly auth = inject(AuthService);
  private readonly tenantService = inject(FrontendConfigurationService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (this.auth.getAccessToken() && this.auth.getRefreshToken()) {
      const route = this.tenantService.defaultRoute();
      this.router.navigateByUrl(route);
      return false;
    }
    return true;
  }
}

export const AntiAuthGuard: CanActivateFn = () => {
  return inject(PermissionsService).canActivate();
};
